const flights = {
  flight: "비행", // translated 
  flights: "항공편", // translated 
  originDepartureDate: "출발", // translated 
  destinationDepartureDate: "반품", // translated 
  outbound: "배 밖으로", // translated 
  inbound: "인바운드", // translated 
  travelTime: "이동 시간", // translated 
  selected: "선택된", // translated 
  select: "선택하다", // translated 
  airline: "공기 호스", // translated 
  directFlight: "직항편", // translated 
  baggage: "수하물", // translated 
  stops: "정지", // translated 
  nonStop: "논스톱", // translated 
  oneStopMax: "원스톱 맥스", // translated 
  twoStopsMax: "최대 두 정류장", // translated 
  anyStops: "모든 정류장에서", // translated 
  smallBaggage: "작은 수하물", // translated 
  bigBaggage: "큰 짐", // translated 
  smallAndBigBaggage: "작은 가방과 큰 가방", // translated 
  outboundStops: "출발 정류장", // translated 
  inboundStops: "도착 정류장", // translated 
  selectAirline: "항공사 선택", // translated 
  baggageOption: "수하물 옵션", // translated 
  outboundDepartureAfter: "출발 후", // translated 
  outboundArrivalAfter: "출국 도착 후", // translated 
  inboundDepartureAfter: "입국 출발 후", // translated 
  inboundArrivalTimeAfter: "입국 후", // translated 
  flightClass: "항공편 등급", // translated 
  outboundDepAfter: "출발 후", // translated 
  outboundArrivalAfrer: "도착 후", // translated 
  inboundDepAfter: "출발 후", // translated 
  inboundArrivalAfter: "도착 후", // translated 
  airlines: "항공사", // translated 
  lessThan: "미만", // translated 
  layover: "중단", // translated 
  duration: "지속", // translated 
  noClassPreference: "계급 선호 없음", // translated 
  economy: "경제", // translated 
  business: "사업", // translated 
  with: "와 함께", // translated 
  without: "없이", // translated 
  twoOrMore: "두 개 이상", // translated 
  departure: "출발", // translated 
  return: "반품", // translated 
  submit: "제출하다", // translated 
  priceLessThan: "가격보다 저렴함", // translated 
  durationLessThan: "기간 미만", // translated 
  layoverLessThan: "경유 시간이 1초 미만인 경우", // translated 
  noLayover: "경유 없음", // translated 
  durationLowestFirst: "소요 시간 (가장 짧은 순서)", // translated 
  durationHighestFirst: "지속 시간 (가장 긴 순서)", // translated 
  idType: "ID 유형", // translated 
  idPassportCode: "신분증/여권 코드", // translated 
  expirationDate: "만료일", // translated 
  frequentFlyerNumber: "마일리지 회원 번호", // translated 
  frequentFlyerAirline: "상용고객 항공사", // translated 
  dateOfBirth: "생일", // translated 
  infant: "유아", // translated 
  phone: "핸드폰", // translated 
  title: "제목", // translated 
  noLuggageIncluded: "수하물은 포함되어 있지 않습니다.", // translated 
  includesLuggage: "수하물 포함", // translated 
  outboundFlight: "출발 항공편", // translated 
  inboundFlight: "입국 항공편", // translated 
  flightNumber: "항공편 번호", // translated 
  flightNumbers: "항공편 번호", // translated 
  cabinClassType: "객실 등급 유형", // translated 
  class: "수업", // translated 
  aircraft: "항공기", // translated 
  aircraftType: "항공기 종류", // translated 
  airlineName: "항공사 이름", // translated 
  no: "아니요", // translated 
  yes: "예", // translated 
  anyFlights: "모든 항공편", // translated 
  oneStop: "원스톱", // translated 
  direct: "직접", // translated 
  directFlights: "직항편", // translated 
  all: "모두", // translated 
  first: "첫 번째", // translated 
  premiumEconomy: "프리미엄 경제", // translated 
  withBaggageOnly: "수하물만 소지한 상태로", // translated 
  oneWay: "편도", // translated 
  roundTrip: "왕복", // translated 
  withBaggage: "수하물 포함", // translated 
  noBaggagePreference: "수하물 선호 없음", // translated 
  noBaggage: "수하물 없음", // translated 
  requiredFields: "필수 입력 항목", // translated 
  nonRequiredFields: "필수 입력 항목이 아닌 입력 항목", // translated 
  cabinClass: "객실 등급", // translated 
  brandName: "브랜드 이름", // translated 
  performNewSearch: "새로운 검색을 수행하세요", // translated 
  outboundDeparture: "출발", // translated 
  inboundDeparture: "입국 출발", // translated 
  created: "생성됨", // translated 
  freeCancellationAvailable: "무료 취소 가능", // translated 
  freeCancellationDeadline: "무료 취소 마감일", // translated 
  externalReference: "외부 참조", // translated 
  outboundflightNumber: "출발 항공편 번호", // translated 
  inboundflightNumber: "도착 항공편 번호", // translated 
  arrival: "도착", // translated 
  originAirport: "출발 공항", // translated 
};


export default flights;
